<button
    *ngIf="!isTextButton else buttonTemplateText"
    class="border-solid border-2 w-full"
    [ngClass]="{
      'text-white' : isPrimaryButton,
      'hover:bg-blue-900 bg-crayola border-crayola' : isPrimaryButton && !isDisabled,
      'text-crayola' : isOutlineButton,
      'hover:bg-crayola hover:text-white border-blue-500 bg-white' : isOutlineButton && !isDisabled,
      'bg-[#4F88D9] border-[#4F88D9]' : isPrimaryButton && isDisabled,
      'opacity-50' : isOutlineButton && isDisabled,
      'rounded-3xl' : isRounded,
      'px-4 py-1 text-sm' : isMediumButton,
      'px-6 py-1.5 text-base' : isLargeButton
    }"
    (click)="handleClick($event)">
    <span>{{ label }}</span>
</button>

<ng-template #buttonTemplateText>
    <span
        class="flex"
        [ngClass]="{'flex-row-reverse justify-end': iconDirection === iconDirectionEnum.RIGHT}"
    >
        <ng-content></ng-content>
        <a (click)="handleClick($event)" [ngClass]="{
          'text-crayola cursor-pointer hover:underline': !isDisabled,
        }">{{ label }}</a>
    </span>
</ng-template>
